import Model, { attr, hasMany } from '@ember-data/model';
import type TeamConversationLinkModel from 'uplisting-frontend/models/team-conversation-link';
import type TeamConversationMemberModel from 'uplisting-frontend/models/team-conversation-member';

export enum TeamConversationKind {
  anchored = 'anchored',
  channel = 'channel',
}

export default class TeamConversationModel extends Model {
  @attr('string') kind!: TeamConversationKind;
  @attr('string') title?: string | null;
  @attr('number') messagesCount!: number;
  @attr('date') lastMessageAt?: Date | null;
  @attr('date') createdAt!: Date;
  @attr('string') anchorResourceType?: string | null;
  @attr('string') anchorResourceId?: string | null;
  @attr('string') anchorResourceLabel?: string | null;
  @attr('string') anchorResourceSublabel?: string | null;
  @attr('string') anchorResourceKind?: string | null;
  @attr('boolean') unread!: boolean;
  @attr('string') lastMessageBody?: string | null;
  @attr('string') lastMessageAuthorName?: string | null;
  @attr('string') lastMessageAuthorUserId?: string | null;
  @attr('number') unreadMentionsCount!: number;

  @hasMany('team-conversation-link', {
    async: false,
    inverse: 'teamConversation',
  })
  teamConversationLinks!: TeamConversationLinkModel[];

  @hasMany('team-conversation-member', { async: false, inverse: null })
  teamConversationMembers!: TeamConversationMemberModel[];

  get isTaskAnchored(): boolean {
    return this.anchorResourceType === 'task';
  }

  get isBookingAnchored(): boolean {
    return this.anchorResourceType === 'booking';
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'team-conversation': TeamConversationModel;
  }
}
